import { render } from "./StarRating.vue?vue&type=template&id=2e9fab27&scoped=true"
import script from "./StarRating.vue?vue&type=script&lang=js"
export * from "./StarRating.vue?vue&type=script&lang=js"

import "./StarRating.vue?vue&type=style&index=0&id=2e9fab27&scoped=true&lang=css"

import exportComponent from "E:\\coding\\desktop\\namya-poll\\namya-poll\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e9fab27"]])

export default __exports__